import { lazy } from 'react';
import { permissions } from '../../_constants/permissions';
import ContactHeader from '../pages/admin/care/contact/ContactHeader';
import HowTo from '../pages/how-to/HowTo';

// Lazy load components
const BehaviorIndex = lazy(() => import('../pages/admin/care/behavior/BehaviorIndex'));
const DescriptionTable = lazy(() => import('../reusable-components/description-modal/DescriptionTable'));
const ProfessionalClaim = lazy(() => import('../pages/billing/professionalclaim/ProfessionalClaim'));
const Chat = lazy(() => import('../../_metronic/layout/components/header/chat_system/chat'));
const CareAdmin = lazy(() => import('../pages/admin/care/AdminCare'));
const IndividualIntakeHeader = lazy(() => import('../pages/admin/care/individual-intake/IndividualIntakeIndex'));
const GeneralAdmin = lazy(() => import('../pages/admin/general/General'));
const BillingAdmin = lazy(() => import('../pages/admin/billing/AdminBilling'));
const ScoringMethods = lazy(() => import('../pages/caregiver/ScoringMethods/ScoringMethods'));
const UploadFiles = lazy(() => import('../pages/importClients'));
const UploadCaregivers = lazy(()=> import('../pages/caregiver/General/Import/CaregiverImport'))
const NotificationManager = lazy(() => import('../pages/notification-manager/NotificationManager'));
const ListMethod = lazy(() => import('../pages/admin/general/scoring-method/List'));
const ClientHelper = lazy(() => import('../reusable-components/ClientHelper'));

export const allRoutes = [
  // {
  //   path: '/import/clients',
  //   component: UploadFiles,
  //   permission: permissions.user_management_import_data_view,
  // },
  // {
  //   path: '/how-to',
  //   component: HowTo,
  //   permission: true,
  // },
  {
    path: '/admin/billing',
    component: BillingAdmin,
    permission: true,
  },
  {
    path: '/chat',
    component: Chat,
    permission: true,
  },
  {
    path: '/notification-manager',
    component: NotificationManager,
    permission: 'USER_MANAGEMENT.NOTIFICATION_MANAGER.VIEW',
  },
  {
    path: '/admin/care/individual-intake',
    component: IndividualIntakeHeader,
    permission: 'ADMIN.CARE.CLIENTS.VIEW',
  },
  {
    path: '/admin/care/contact',
    component: ContactHeader,
    permission: 'ADMIN.CARE.CONTACT.VIEW',
  },
  {
    path: '/admin/general/scoring-method',
    component: ListMethod,
    permission: true,
  },
  {
    path: '/admin/care',
    component: CareAdmin,
    permission: 'ADMIN.CARE.VIEW',
  },
  {
    path: '/admin/care/behavior',
    component: BehaviorIndex,
    permission: true,
  },
  {
    path: '/admin/care',
    exact: true,
    to: '/care',
    permission: 'ADMIN.CARE.VIEW',
  },
  {
    path: '/admin/general',
    exact: true,
    component: GeneralAdmin,
    permission: true,
  },
  {
    path: '/billing/professionalclaim',
    component: ProfessionalClaim,
    permission: true,
  },
  {
    path: '/caregivers/scoringMethods',
    component: ScoringMethods,
    permission: true,
  },
  {
    path: '/edit-histories',
    component: DescriptionTable,
  },
  {
    path:"/help",
    component:ClientHelper,
  },
];

export const allroutesHandler = () => {}; // Leave this if you need it

// Example of how to use these routes with Suspense in your Router/Switch:
// ... inside your Router/Switch component:
// {allRoutes.map((route, index) => (
//   <Route
//     key={index}
//     path={route.path}
//     exact={route.exact}
//     render={() => (
//       <Suspense fallback={<Loading />}>
//         {React.createElement(route.component)}
//       </Suspense>
//     )}
//   />
// ))}